var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _PLACEMENT_CLASSNAMES;
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { hintCls, hintDefautlChildrenCls, hintPaddedCls, hintTypeTooltipCls, hintTypeHintCls, hintArrowCls, hintContentCls, hintPlacementNWCls, hintPlacementNCls, hintPlacementNECls, hintPlacementSWCls, hintPlacementSCls, hintPlacementSECls, hintPlacementENCls, hintPlacementECls, hintPlacementESCls, hintPlacementWNCls, hintPlacementWCls, hintPlacementWSCls } from "./Hint.less";
var TYPE_TO_CLASSNAME = {
  tooltip: hintTypeTooltipCls,
  hint: hintTypeHintCls
};
var PLACEMENTS = {
  NW: "NW",
  N: "N",
  NE: "NE",
  EN: "EN",
  E: "E",
  ES: "ES",
  SE: "SE",
  S: "S",
  SW: "SW",
  WS: "WS",
  W: "W",
  WN: "WN"
};
var PLACEMENT_CLASSNAMES = (_PLACEMENT_CLASSNAMES = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_PLACEMENT_CLASSNAMES, PLACEMENTS.NW, hintPlacementNWCls), PLACEMENTS.N, hintPlacementNCls), PLACEMENTS.NE, hintPlacementNECls), PLACEMENTS.EN, hintPlacementENCls), PLACEMENTS.E, hintPlacementECls), PLACEMENTS.ES, hintPlacementESCls), PLACEMENTS.SW, hintPlacementSWCls), PLACEMENTS.S, hintPlacementSCls), PLACEMENTS.SE, hintPlacementSECls), PLACEMENTS.WS, hintPlacementWSCls), _defineProperty(_defineProperty(_PLACEMENT_CLASSNAMES, PLACEMENTS.W, hintPlacementWCls), PLACEMENTS.WN, hintPlacementWNCls));
var Hint = /* @__PURE__ */ __name(function Hint2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "tooltip" : _ref$type, _ref$padded = _ref.padded, padded = _ref$padded === void 0 ? false : _ref$padded, children = _ref.children, wrapperTag = _ref.wrapperTag, wrapperClassName = _ref.wrapperClassName, hintArrowClassName = _ref.hintArrowClassName, hintContentClassName = _ref.hintContentClassName, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? PLACEMENTS.N : _ref$placement, text = _ref.text, _ref$customStyle = _ref.customStyle, customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle;
  var WrapperTag = wrapperTag;
  return /* @__PURE__ */ React.createElement(WrapperTag, {
    className: classNames(hintCls, !children ? hintDefautlChildrenCls : null, TYPE_TO_CLASSNAME[type] || TYPE_TO_CLASSNAME.tooltip, PLACEMENT_CLASSNAMES[placement.toUpperCase()] || PLACEMENT_CLASSNAMES.N, padded && hintPaddedCls, wrapperClassName),
    style: customStyle
  }, children || /* @__PURE__ */ React.createElement("i", null, "?"), /* @__PURE__ */ React.createElement("div", {
    className: classNames(hintArrowCls, hintArrowClassName)
  }), /* @__PURE__ */ React.createElement("div", {
    className: classNames(hintContentCls, hintContentClassName)
  }, text));
}, "Hint");
export {
  Hint
};
